import * as THREE from 'three'

export default class TextureManager
{
    constructor ()
    {
        const textureLoader = new THREE.TextureLoader()
        this.matcapTex = textureLoader.load('./textures/models/matcap.png')
        this.topGradientTex = textureLoader.load('./textures/models/top-gradient.png')
        this.alphaMapTex = textureLoader.load('./textures/models/matcap-alphamap.png')
        this.alphaMapTex2 = textureLoader.load('./textures/models/matcap-alphamap2.png')
    }
}